
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { BAIconsMixin } from '@/mixins';
import { CalendarEventModel } from '@/models/calendar/CalendarEventModel';
import { CalendarEventsApi } from '@/api/CalendarApi';
import { CalendarEventAssignment } from '@/../types/interfaces';

@Component
export default class EventAssignments extends Mixins(BAIconsMixin) {
	@Prop({ required: true }) event: CalendarEventModel;
	@Prop({ required: true }) calendarEventsApi: CalendarEventsApi;
	@Prop({ default: false }) isCoach: boolean;
	@Prop({ default: null }) myParticipantId: string | null;

	showAdd = false;
	newTitle = '';
	newDescription = '';
	saving = false;
	toggling: string | null = null;
	deleting: string | null = null;

	get Assignments(): CalendarEventAssignment[] { return this.event.assignments || []; }
	isCompletedByMe(a: CalendarEventAssignment): boolean {
		return !!this.myParticipantId && a.completedBy.includes(this.myParticipantId);
	}
	emitUpdated(updated: CalendarEventModel): void { this.$emit('updated', updated); }

	async add(): Promise<void> {
		if (!this.newTitle.trim()) return;
		this.saving = true;
		try {
			const updated = await this.calendarEventsApi.addAssignment(this.event.id, { title: this.newTitle, description: this.newDescription });
			this.emitUpdated(updated);
			this.newTitle = ''; this.newDescription = ''; this.showAdd = false;
		} catch (e) { /* eslint-disable-next-line no-console */ console.error('Failed to add assignment', e); }
		finally { this.saving = false; }
	}
	async toggle(a: CalendarEventAssignment): Promise<void> {
		if (!this.myParticipantId) return;
		this.toggling = a.id;
		try { this.emitUpdated(await this.calendarEventsApi.toggleAssignment(this.event.id, a.id)); }
		catch (e) { /* eslint-disable-next-line no-console */ console.error('Failed to toggle assignment', e); }
		finally { this.toggling = null; }
	}
	async remove(a: CalendarEventAssignment): Promise<void> {
		this.deleting = a.id;
		try { this.emitUpdated(await this.calendarEventsApi.deleteAssignment(this.event.id, a.id)); }
		catch (e) { /* eslint-disable-next-line no-console */ console.error('Failed to delete assignment', e); }
		finally { this.deleting = null; }
	}
}
